import { cn } from './cn';

/**
 * <IconBox color="cyan" size="md"><Icon size={16}/></IconBox>
 *
 * Mini-cuadrado redondeado con color tonal para iconos en listas/menus.
 * Estilo similar al command palette de EDteam.
 *
 * Colors: cyan | purple | amber | green | red | blue | neutral
 * Sizes:  sm (28px) | md (32px) | lg (40px)
 */
const COLORS = {
    cyan:    'bg-cyan2/15   text-cyan2',
    purple:  'bg-purple2/15 text-purple2',
    amber:   'bg-warning/15 text-warning',
    green:   'bg-success/15 text-success',
    red:     'bg-danger/15  text-danger',
    blue:    'bg-primary/15 text-primary',
    neutral: 'bg-surface-2  text-muted'
};

const SIZES = {
    sm: 'w-7 h-7 rounded-md',
    md: 'w-8 h-8 rounded-lg',
    lg: 'w-10 h-10 rounded-lg'
};

const IconBox = ({ color = 'cyan', size = 'md', className, children, ...rest }) => (
    <span
        className={cn(
            'inline-flex items-center justify-center shrink-0',
            COLORS[color] || COLORS.cyan,
            SIZES[size] || SIZES.md,
            className
        )}
        {...rest}
    >
        {children}
    </span>
);

export default IconBox;
